// extracted by mini-css-extract-plugin
export default {"about-content":"_47OH0oFC-mLAdhhpKVU+dA==","about-code":"Za+GwCRh9FT2QTjH2P6rtw==","about-contact":"pUm8LKfUdYfeuyCvNfYubg=="};